const ENV = {
  LCL: {
    API_SERVER: "http://localhost:1992",
    // API_SERVER: "https://api.baotinhoanggia.com",
    S3_ASSETS_BUCKET: "https://home-assets.baotinhoanggia.com",
    GG_MAP_KEY: "AIzaSyCccs_K2c4m1bT-xAiFRa1bu9EIKRoD_Y4",
  },

  PRO: {
    API_SERVER: "https://api.baotinhoanggia.com",
    S3_ASSETS_BUCKET: "https://home-assets.baotinhoanggia.com",
    GG_MAP_KEY: "AIzaSyCccs_K2c4m1bT-xAiFRa1bu9EIKRoD_Y4",
  },
};

const config = ENV[process.env.REACT_APP_STAGE || "LCL"];

const getEnv = (name, defaultValue) => {
  return process.env[name] || config[name] || defaultValue;
};

export {getEnv};



// WEBPACK FOOTER //
// ./src/env.js